import React from "react";
import { graphql } from "gatsby";
const helpers = require("../helpers");

import Layout from "../components/layout";

import Header from "../components/organisms/header";
import Footer from "../components/organisms/footer";
import Section from "../components/organisms/section";
import SolutionsTeaser from "../components/organisms/solutions-teaser";
import OurClients from "../components/organisms/our-clients";

import HeaderBrand from "../components/molecules/header-brand";
import HeaderCta from "../components/molecules/header-cta";
import FooterBrand from "../components/molecules/footer-brand";
import FooterNav from "../components/molecules/footer-nav";
import FooterCopy from "../components/molecules/footer-copy";
import NavBar from "../components/molecules/navbar";
import Hero from "../components/molecules/hero";
import LinkList from "../components/molecules/link-list";
import LinkListItem from "../components/molecules/link-list-item";
import Image from "../components/molecules/image";

import Button from "../components/atoms/button";
import Seo from "../components/atoms/seo";
import DictionaryEntry from "../components/atoms/dictionary-entry";

class RootIndex extends React.Component {
  render() {
    const dictionaryEdges = this.props.data.allContentfulDictionaryEntry.edges;

    return (
      <Layout location={this.props.location}>
        <Seo
          title={helpers.getShortValueFromDictionary(
            dictionaryEdges,
            "home-page.seo-title",
            this.props.pageContext.language
          )}
        />
        <Header darkBg={true}>
          <HeaderBrand darkBg={false} />
          <NavBar
            context={this.props.pageContext.intl}
            darkBg={false}
            language={this.props.pageContext.language}
          />
          <Hero
            fluid={this.props.data.headerImage.childImageSharp.fluid}
            alt={helpers.getShortValueFromDictionary(
              dictionaryEdges,
              "home-page.hero.image-alt",
              this.props.pageContext.language
            )}
            title="Blastic"
            tagline={helpers.getShortValueFromDictionary(
              dictionaryEdges,
              "home-page.general.tag-line",
              this.props.pageContext.language
            )}
          />
          <HeaderCta
            dictionaryEdges={dictionaryEdges}
            language={this.props.pageContext.language}
          />
        </Header>
        <SolutionsTeaser
          dictionaryEdges={dictionaryEdges}
          language={this.props.pageContext.language}
        />
        <Section className="pt-5 pb-6 section-blue">
          <h2 className="mb-4">
            <DictionaryEntry
              dictionaryEdges={dictionaryEdges}
              dictionaryKey="home-page.job-teaser.title"
              language={this.props.pageContext.language}
            />
          </h2>
          <div className="row">
            <div className="col-md-5 pb-md-7 mr-auto">
              <p>
                <DictionaryEntry
                  dictionaryEdges={dictionaryEdges}
                  dictionaryKey="home-page.job-teaser.body"
                  language={this.props.pageContext.language}
                />{" "}
                <a href="mailto:info@blastic.com">info@blastic.com</a>
              </p>
              <Button
                to="jobs"
                type="secondary"
                pointLess={true}
                className="mt-4"
              >
                <DictionaryEntry
                  dictionaryEdges={dictionaryEdges}
                  dictionaryKey="home-page.job-teaser.cta"
                  language={this.props.pageContext.language}
                />
              </Button>
            </div>
            <div className="col-md-6">
              <LinkList>
                <LinkListItem to="jobs/requirements-and-qa-consultant">
                  Requirements &amp; QA Consultant Silhouette
                </LinkListItem>
                <LinkListItem to="jobs/back-end-silhouette">
                  Back-end developer Silhouette
                </LinkListItem>
                <LinkListItem to="jobs/front-end-silhouette">
                  Front-end developer Silhouette
                </LinkListItem>
                {/* <LinkListItem to="jobs/designer-silhouette">
                  UX/UI Designer Silhouette
                </LinkListItem> */}
                {/* <LinkListItem to="jobs/digital-marketer-silhouette">
                  Digital Marketer Silhouette
                </LinkListItem> */}
              </LinkList>
            </div>
          </div>
        </Section>
        <Section className="pt-0 pb-0" isFluid={true}>
          <div className="row">
            <div className="col-sm-6 order-sm-2 py-5 d-flex flex-column">
              <div className="mt-auto mb-auto">
                <p className="h3 mb-4">
                  <DictionaryEntry
                    dictionaryEdges={dictionaryEdges}
                    dictionaryKey="home-page.articles.title"
                    language={this.props.pageContext.language}
                  />
                </p>
                <Button to="articles" type="clean">
                  <DictionaryEntry
                    dictionaryEdges={dictionaryEdges}
                    dictionaryKey="home-page.articles.cta"
                    language={this.props.pageContext.language}
                  />
                </Button>
              </div>
            </div>
            <div className="col-sm-5 mr-auto order-sm-1">
              <Image
                fluid={this.props.data.collaborateImage.childImageSharp.fluid}
                alt={helpers.getShortValueFromDictionary(
                  dictionaryEdges,
                  "home-page.articles.image-alt",
                  this.props.pageContext.language
                )}
                overlay="gradient"
                negateTop={true}
                negateLeft={true}
                aspectRatio="1-5x1"
              />
            </div>
          </div>
        </Section>
        <OurClients
          dictionaryEdges={dictionaryEdges}
          language={this.props.pageContext.language}
        />
        <Footer>
          <FooterBrand />
          <FooterNav language={this.props.pageContext.language} />
          <FooterCopy />
        </Footer>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    sitecoreTeaser: file(
      relativePath: { eq: "background/sitecore-10-webinar-teaser.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 400, quality: 100) {
          # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    headerImage: file(relativePath: { eq: "blastic-vibe/KT0A4693.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 1200, quality: 10) {
          # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    collaborateImage: file(relativePath: { eq: "blastic-vibe/KT0A4666.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 800, quality: 100) {
          # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    allContentfulDictionaryEntry(filter: { key: { regex: "/home-page/i" } }) {
      edges {
        node {
          key
          shortValue
          richValue {
            raw
          }
          node_locale
        }
      }
    }
  }
`;

export default RootIndex;
